import { appendJatsElement } from '../xml-helpers';

export interface AbstractInput {
  abstract?: string;
  language?: string;
}

export function buildAbstracts(
  parent: Element,
  abstracts: AbstractInput[] | undefined
): void {
  if (!Array.isArray(abstracts) || abstracts.length === 0) return;

  for (const a of abstracts) {
    if (!a.abstract) continue;

    const attrs: Record<string, string> = {};
    if (a.language) {
      attrs['xml:lang'] = a.language;
    }

    const abstractEl = appendJatsElement(parent, 'abstract', null, attrs);
    appendJatsElement(abstractEl, 'p', a.abstract);
  }
}
